/**
 * G1 Modal - Lightweight modal functionality for G1 sections
 * @version 1.0.0
 */

class G1Modal {
    constructor(modalId) {
      this.modalId = modalId;
      this.modal = null;
      this.isOpen = false;
      
      // Initialize when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }
  
    init() {
      this.modal = document.getElementById(this.modalId);
      
      if (!this.modal) {
        console.warn('G1Modal: Modal not found with ID:', this.modalId);
        return;
      }
  
      console.log('✅ G1Modal initialized:', this.modalId);
    }
  
    open() {
      if (!this.modal) return;
      
      console.log('Opening modal:', this.modalId);
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
    }
  
    close() {
      if (!this.modal) return;
      
      console.log('Closing modal:', this.modalId);
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      this.isOpen = false;
    }
  
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }
  
  // Tab switching functionality
  class G1Tabs {
    constructor(containerId) {
      this.containerId = containerId;
      this.container = null;
      this.tabs = [];
      this.contents = [];
      
      // Initialize when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }
  
    init() {
      this.container = document.getElementById(this.containerId);
      
      if (!this.container) {
        console.warn('G1Tabs: Container not found with ID:', this.containerId);
        return;
      }
  
      this.tabs = this.container.querySelectorAll('.one-tab');
      
      if (!this.tabs.length) {
        // Fallback to old structure
        this.tabs = this.container.querySelectorAll('.supplement-facts-tab');
        this.contents = this.container.querySelectorAll('.supplement-facts-tab-content');
      }
  
      console.log('✅ G1Tabs initialized:', this.containerId, '- Tabs:', this.tabs.length);
    }
  
    switchTo(tabName) {
      console.log('Switching to tab:', tabName);
      
      // Map tab names to indices
      const tabIndex = tabName === 'facts' ? '1' : '2';
      
      // Remove active class from all tabs
      this.tabs.forEach(tab => tab.classList.remove('active'));
      
      // Find and activate the tab by index
      const activeTab = Array.from(this.tabs).find(tab => 
        tab.dataset.index === tabIndex
      );
      if (activeTab) activeTab.classList.add('active');
      
      // Show/hide dynamic content by data-index
      const dynamicContent = this.container.querySelector('.dynamic-content');
      if (dynamicContent) {
        const allDynamicItems = dynamicContent.querySelectorAll('[data-index]');
        allDynamicItems.forEach(item => {
          if (item.dataset.index === tabIndex) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      }
    }
  }
  
  // Export for use in other modules
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { G1Modal, G1Tabs };
  }
  
  